export const TOAST_COLORS = {
  success: {
    bg: "#EFFDF5",
    border: "#A7F3D0",
    // shadowColor: "#6EE7B7",
    color: "#064E3B",
    iconColor: "#059669",
  },
  error: {
    bg: "#FEF2F4",
    border: "#FECDD3",
    // shadowColor: "#FDA4AF",
    color: "#881337",
    iconColor: "#E11D48",
  },
  warning: {
    bg: "#FFFBEB",
    border: "#FDE68A",
    // shadowColor: "#FCD34D",
    color: "#78350F",
    iconColor: "#D97706",
  },
  info: {
    bg: "#F0F9FF",
    border: "#BAE6FD",
    // shadowColor: "#7DD3FC",
    color: "#0C4A6E",
    iconColor: "#0284C7",
  },
};

export const normalizeSeverity = (severity) => {
  if (!severity) return "info";
  const s = String(severity).toLowerCase();
  if (s === "danger") return "error";
  if (s === "warn") return "warning";
  if (["success", "info", "warning", "error"].includes(s)) return s;
  return "info";
};

export const getToastAlertSx = (severity = "info", customSx = {}) => {
  const norm = normalizeSeverity(severity);
  const colorConfig = TOAST_COLORS[norm] || TOAST_COLORS.info;
  return {
    width: "100%",
    backgroundColor: `${colorConfig.bg} !important`,
    color: `${colorConfig.color} !important`,
    border: `1.5px solid ${colorConfig.border}`,
    borderRadius: "18px",
    // boxShadow: `-4px 4px 0px 0px ${colorConfig.shadowColor}, 0 6px 20px rgba(0, 0, 0, 0.08)`,
    fontWeight: 600,
    fontSize: "0.875rem",
    p: "8px 14px",
    "& .MuiAlert-icon": {
      backgroundColor: "#FFFFFF !important",
      borderRadius: "12px",
      border: `1.5px solid ${colorConfig.border}`,
      p: "6px",
      color: `${colorConfig.iconColor} !important`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      mr: 1.5,
    },
    "& .MuiAlert-action": {
      color: `${colorConfig.iconColor} !important`,
      pt: 0,
    },
    "& .MuiAlert-message": {
      color: `${colorConfig.color} !important`,
      fontWeight: 500,
      fontSize: "0.875rem",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    ...customSx,
  };
};
